// @flow
import React, { Component } from 'react';
import CategoryEditModal from 'components/write/CategoryEditModal';
import CategoryEditItemList from 'components/write/CategoryEditItemList';
import { connect } from 'react-redux';
import type { State } from 'store';
import { WriteActions } from 'store/actionCreators';
import type { Categories } from 'store/modules/write';

type Props = {
  open: boolean,
  parent: any,
  categories: ?Categories,
  selectCategory1: ?Categories,
  selectCategory2: ?Categories,
  ordered: boolean,
};

class CategoryEditModalContainer extends Component<Props> {
  onClose = () => {
    WriteActions.closeCategoryModal();
  };
  onCreate = (order, parent: any) => {
    WriteActions.createTempCategory({
      order,
      parent,
    });
  };
  onToggleEditCategory = id => {
    WriteActions.toggleEditCategory(id);
  };
  onChange = ({
    id,
    name,
    order,
    parent,
  }: {
    id: string,
    name: string,
    order: number,
    parent: string,
  }) => {
    WriteActions.changeCategoryName({
      id,
      name,
      order,
      parent,
    });
  };
  onHideCategory = (id: string) => {
    WriteActions.hideCategory(id);
  };
  onSelectCategory1 = (id: string) => {
    WriteActions.selectCategory1(id);
  };
  onSelectCategory2 = (id: string) => {
    WriteActions.selectCategory2(id);
  };
  onSave = async () => {
    WriteActions.closeCategoryModal();
    const { categories } = this.props;
    if (!categories) return;
    const shouldCreate = categories.filter(c => c.temp && !c.hide);
    const shouldRemove = categories.filter(c => c.hide);
    const shouldUpdate = categories.filter(c => c.edited && !c.temp && !c.hide);

    try {
      const create = shouldCreate.map(c =>
        WriteActions.createCategory(c.name, c.order, c.parent, c.id),
      );
      const remove = shouldRemove.map(c => WriteActions.deleteCategory(c.id));
      const update = shouldUpdate.map(c =>
        WriteActions.updateCategory({
          id: c.id,
          name: c.name,
          order: c.order,
          parent: c.parent,
        }),
      );
      await Promise.all(create);
      await Promise.all(remove);
      await Promise.all(update);
    } catch (e) {
      console.log(e);
    }
  };

  initialize = () => {};

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.open && this.props.open) {
      this.initialize();
    }
  }

  render() {
    const { open, categories, selectCategory1, selectCategory2 } = this.props;
    if (!categories) return null;
    const categoryList1 = categories.filter(doc => doc.order === 1);
    const categoryList2 = selectCategory1
      ? categories.filter(doc => doc.order === 2 && doc.parent === selectCategory1)
      : null;
    const categoryList3 = selectCategory2
      ? categories.filter(doc => doc.order === 3 && doc.parent === selectCategory2)
      : null;
    const {
      onClose,
      onCreate,
      onToggleEditCategory,
      onChange,
      onHideCategory,
      onSelectCategory1,
      onSelectCategory2,
      onSave,
    } = this;

    return (
      <CategoryEditModal open={open} onClose={onClose} onSave={onSave} onCreate={onCreate}>
        <CategoryEditItemList
          type={1}
          categories={categoryList1}
          onCreate={() => onCreate(1, null)}
          onToggleEditCategory={onToggleEditCategory}
          onChange={onChange}
          onHideCategory={onHideCategory}
          onSelectCategory1={onSelectCategory1}
        />
        <CategoryEditItemList
          type={2}
          categories={categoryList2}
          onCreate={() => onCreate(2, selectCategory1)}
          onToggleEditCategory={onToggleEditCategory}
          onChange={onChange}
          onHideCategory={onHideCategory}
          onSelectCategory2={onSelectCategory2}
        />
        <CategoryEditItemList
          type={3}
          categories={categoryList3}
          onCreate={() => onCreate(3, selectCategory2)}
          onToggleEditCategory={onToggleEditCategory}
          onChange={onChange}
          onHideCategory={onHideCategory}
        />
      </CategoryEditModal>
    );
  }
}

export default connect(
  ({ write }: State) => ({
    open: write.categoryModal.open,
    categories: write.categoryModal.categories,
    selectCategory1: write.categoryModal.selectCategory1,
    selectCategory2: write.categoryModal.selectCategory2,
    ordered: write.categoryModal.ordered,
  }),
  () => ({}),
)(CategoryEditModalContainer);



// WEBPACK FOOTER //
// ./src/containers/write/CategoryEditModalContainer.js